import { useState } from 'react'

import { customPost } from '../utils/customFetch.ts'

import { makeUrlDealCancel } from './connectionData.tsx'
import { useAuth } from './useAuth.tsx'
const apiUrl = makeUrlDealCancel()

const useDealCancel = () => {
  const [dealCancelError, setDealCancelError] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const { userData } = useAuth()

  const dealCancel = async (_id: string, cause: string, reason: string) => {
    setLoading(true)

    try {
      const by = userData?.profile?._id ?? ''
      await customPost(apiUrl, { _id, cause, by, reason })

      setDealCancelError(null)
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setDealCancelError(err)
      } else {
        setDealCancelError(new Error('An unknown error occurred'))
      }
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { dealCancelError, loading, dealCancel }
}
export default useDealCancel
